import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { GradeBreakdownContentComponent } from "../grade-breakdown-content/grade-breakdown-content.component";

@Component({
  selector: "app-overall-grade-breakdown-header",
  templateUrl: "./overall-grade-breakdown-header.component.html",
  styleUrls: ["./overall-grade-breakdown-header.component.scss"],
  standalone: true,
  imports: [CommonModule, GradeBreakdownContentComponent],
})
export class OverallGradeBreakdownHeaderComponent {
  isExpanded: boolean = false;
  @Input() isFullScreen: boolean = false;
  @Input() isNewPage: boolean = false;
  constructor() {}

  toggleExpanded(): void {
    this.isExpanded = !this.isExpanded;
  }

  dropdownOpen = false;

toggleDropdown() {
  this.dropdownOpen = !this.dropdownOpen;
}

downloadPDF() {
  // your logic here
}

exportCSV() {
  // your logic here
  this.dropdownOpen = false;
}

exportExcel() {
  // your logic here
  this.dropdownOpen = false;
}

}
